import { IPlayUIStateProps } from "../..";
import {
  triggerHomeRequest,
  triggerPluginRequest
} from "../Common/Header.actions";
import { IHeaderMapDispatchProps, IHeaderMapStateProps } from "./Header";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): IHeaderMapStateProps => ({
  homeAvailable: state.header.homeAvailable,
  homeEnabled: state.header.homeEnabled,
  pluginAvailable: state.header.pluginAvailable,
  pluginEnabled: state.header.pluginEnabled,
  pluginMenuButtonIcon: state.header.pluginMenuButtonIcon,
  view: state.view
});

export const sharedMapDispatchToProps = (
  dispatch
): IHeaderMapDispatchProps => ({
  triggerHomeRequest: () => dispatch(triggerHomeRequest()),
  triggerPluginRequest: () => dispatch(triggerPluginRequest())
});
